import React from "react"
import Terms from "../globals/Terms"
import PrivacyPolicy from "../globals/PrivacyPolicy"
import { APP_LOGIN_ORIGIN } from "../../constants"

const Login: React.FC = (): React.ReactElement => {
  return (
    <div className="mx-auto flex min-h-full max-w-[355px] flex-col justify-center pb-[120px] pt-[96px]">
      <div className="mb-[28px] w-full text-center">
        <h2 className="type-heading-lg text-center">Welcome Back!</h2>
        <p className="type-body mt-[8px] text-center">
          Explore, optimize, and transform your digital presence with data-driven insights.
        </p>
      </div>

      <div className="flex flex-col gap-[22px]">
        {/* Secondary button — external link */}
        <a
          href="https://forms.gle/jf2EZUQ4XD3VNtsM6"
          target="_blank"
          rel="noreferrer"
          className="btn-secondary"
          aria-label="Join Waitlist"
        >
          Join Waitlist
        </a>

        {/* Primary button — external link */}
        <a
          href={`${APP_LOGIN_ORIGIN}/`}
          target="_blank"
          rel="noreferrer"
          className="btn-primary"
          aria-label="Login"
        >
          Login
        </a>

        <p className="type-body-muted text-center">
          By submitting this form, you agree to the <Terms /> and <PrivacyPolicy />.
        </p>
      </div>
    </div>
  )
}

export default Login
